export const tableHeader = [
  {
    id: 'name',
    type: 'text',
    value: 'Nome',
  },
  {
    id: 'criticity',
    type: 'select',
    value: 'Criticidade',
    render: (value) => {
      const criticitiesData = {
        '1': { color: '#4caf50', label: 'Muito Baixa' },
        '2': { color: '#8bc34a', label: 'Baixa' },
        '3': { color: '#ff9800', label: 'Média' },
        '4': { color: '#ff5722', label: 'Alta' },
        '5': { color: '#f44336', label: 'Muito Alta' }
      };
      const criticity = criticitiesData[value];
      if (!criticity) return value;
      
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: criticity.color
            }}
          />
          {value} - {criticity.label}
        </div>
      );
    }
  },
  {
    id: 'description',
    type: 'text',
    value: 'Descrição'
  },
  {
    id: 'user',
    type: 'text',
    value: 'Responsável',
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
    minWidth: '140px'
  },
]
